import { http } from './http'

export interface ScanTicketResponse {
  name: string
  ticketCode: string
  email: string
  phone: string
  ticket: string
  status:
    | 'INVALID_TICKET'
    | 'INVALID_TICKET_STATUS'
    | 'EXPIRED_TICKET'
    | 'INVALID_TRANSITION_STATUS'
    | 'ALREADY_CHECKED_IN'
    | 'CHECKED_IN'
    | 'ALREADY_CHECKED_OUT'
    | 'CHECKED_OUT'
}

export const scanCheckIn = (ticketCode: string) =>
  http.put<ScanTicketResponse>(`/operations/tickets/checkin/${ticketCode}`)

export const scanCheckOut = (ticketCode: string) =>
  http.put<ScanTicketResponse>(`/operations/tickets/checkout/${ticketCode}`)
